var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChemistryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chemistry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.561,
    height: 26.561,
    viewBox: "0 0 26.561 26.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_18",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 18",
    d: "M23.241,19.9l-5.989-8.235V3.656h1.656V2H8.969V3.656h1.656v8.013L4.637,19.9a3.328,3.328,0,0,0,2.692,5.286H20.549A3.328,3.328,0,0,0,23.241,19.9Zm-10.959-7.7V3.656H15.6v8.552l2.214,3.044h-7.74Zm8.267,11.326H7.328a1.672,1.672,0,0,1-1.352-2.655l2.888-3.97h10.15l2.888,3.97a1.672,1.672,0,0,1-1.352,2.655Z",
    transform: "translate(-0.687 0.278)",
    fill: "#757575"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 26.561,
    height: 26.561,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistryicon);
export default __webpack_public_path__ + "static/media/chemistry.icon.79009824cbe953b59859201ceb19c244.svg";
export { ForwardRef as ReactComponent };